module.exports = __webpack_public_path__ + "static/media/Rita Rose Headshot.f8a1f82b.jpeg";